import React from 'react';
import Select from '../../../Select';
import './HomeOwnerOnboardingDashboard.scss';
import './Media.scss';

const OrdersList = ({ onboardingData, onFetchOrderDetails }) => {
  return (
    <div className="mainRow">
      <div className="order_selection_mobile_view" style={{ marginTop: 20 }}>
        {onboardingData.orders && onboardingData.orders.length > 0 && (
          <Select
            value={onboardingData.orderId}
            onChange={(e) => onFetchOrderDetails(e.target.value)}
            options={onboardingData.orders.map((order) => ({
              value: order.id,
              label: `${order.title}`,
            }))}
            placeholder="(Select Order)"
            block
          />
        )}{' '}
      </div>

      <ul className="menuScroll">
        {onboardingData.orders && onboardingData.orders.length > 0
          ? onboardingData.orders.map((order) => {
              return (
                <li
                  className={
                    onboardingData && onboardingData.orderId === order.id
                      ? 'list-item active'
                      : 'list-item'
                  }
                  onClick={() => onFetchOrderDetails(order.id)}
                >
                  {order.title}
                </li>
              );
            })
          : null}
      </ul>
    </div>
  );
};

export default OrdersList;
